import React from "react";

function IconShield(props) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.3662 22.5946C12.3662 22.5946 3.38257 19.2047 3.38257 12.8458V3.67846C3.38257 3.67846 6.69596 1.38281 12.3662 1.38281V22.5946Z"
        fill="#7E8DAB"
      />
      <path
        d="M12.3662 1.38281C6.69596 1.38281 3.38257 3.67846 3.38257 3.67846V12.8458C3.38257 19.2047 12.3662 22.5946 12.3662 22.5946C12.3662 22.5946 21.3499 19.2047 21.3499 12.8458V3.67846C21.3499 3.67846 18.0288 1.38281 12.3662 1.38281Z"
        stroke="#7E8DAB"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default IconShield;
